export default __webpack_public_path__ + "static/media/livetv-big.bc1c45cd.jpg";